import styled from "@emotion/styled";
import theme from "@utils/theme";

export const DashboardWrapper = styled.div`
  padding: 0px;
  background: #fafbfc;
  min-height: 100vh;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  @media (max-width: 800px) {
    padding: 0px;
  }
`;

export const HeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`;

export const HeaderText = styled.div`
  h1 {
    font-size: 20px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 4px 0;
  }
  p {
    font-size: 13px;
    color: #6b7280;
    margin: 0;
    font-weight: 400;
  }
`;

export const DateFilter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #374151;
  cursor: pointer;

  &:hover {
    border-color: ${theme.orange.orange300};
  }
`;

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
`;

export const MetricCard = styled.div`
  width: 100%;
  background: white;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #f3f4f6;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    border-color: ${theme.orange.orange200};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }
`;

export const MetricHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const MetricIcon = styled.div<any>`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: ${(props) => props.background};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.color};
`;

export const MetricTrend = styled.div<any>`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  color: ${(props: any) => (props.positive ? "#059669" : "#dc2626")};
`;

export const MetricValue = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 2px;
`;

export const MetricLabel = styled.div`
  font-size: 12px;
  color: #6b7280;
  font-weight: 400;
`;

export const ServicesSection = styled.div`
  margin-bottom: 24px;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const SectionTitle = styled.h2`
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`;

export const ViewAll = styled.div`
  font-size: 12px;
  color: ${theme.orange.orange500};
  font-weight: 500;
  cursor: pointer;

  &:hover {
    color: ${theme.orange.orange600};
  }
`;

export const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
`;

export const ServiceCard = styled.div`
  width: 100%;
  background: white;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid #f3f4f6;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    border-color: ${theme.orange.orange300};
    transform: translateY(-1px);
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: ${theme.orange.orange500};
    transform: scaleX(0);
    transition: transform 0.2s ease;
  }

  &:hover::before {
    transform: scaleX(1);
  }
`;

export const ServiceIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: ${theme.orange.orange50};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.orange.orange500};
  margin-bottom: 12px;
`;

export const ServiceName = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #111827;
  margin-bottom: 4px;
`;

export const ServiceStats = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${theme.orange.orange500};
`;

export const ServiceSubtext = styled.div`
  font-size: 11px;
  color: #9ca3af;
  margin-top: 2px;
`;

export const MainDashboard = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

export const ActivityCard = styled.div`
  background: white;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #f3f4f6;
  flex: 1;
`;

export const ActivityHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const ActivityTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`;

export const ActivityList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ActivityItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background: #fafbfc;
  border-radius: 8px;
  border-left: 2px solid ${theme.orange.orange500};
`;

export const ActivityIcon = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: ${theme.orange.orange50};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.orange.orange500};
  flex-shrink: 0;
  margin-top: 1px;
`;

export const ActivityContent = styled.div`
  flex: 1;
`;

export const ActivityText = styled.div`
  font-size: 12px;
  color: #374151;
  line-height: 1.4;
  margin-bottom: 2px;
`;

export const ActivityTime = styled.div`
  font-size: 11px;
  color: #9ca3af;
  font-weight: 400;
`;

export const BottomSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

export const InfoPanel = styled.div`
  background: white;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #f3f4f6;
  flex: 1;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: between;
  margin-bottom: 16px;
`;

export const PanelTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`;

export const DeliveryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DeliveryItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
  }
`;

export const AgentInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const AgentAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: ${theme.orange.orange50};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.orange.orange500};
  font-size: 11px;
  font-weight: 600;
`;

export const AgentDetails = styled.div``;

export const AgentName = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #111827;
`;

export const AgentStats = styled.div`
  font-size: 11px;
  color: #6b7280;
`;

export const AgentRating = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  color: #d97706;
`;

export const QuickStats = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StatItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 8px;
  border-bottom: 1px solid #f3f4f6;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background: #fafbfc;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const StatLabel = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

export const StatValue = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #111827;
`;

// New Performance Metrics Design
export const PerformanceGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const PerformanceCard = styled.div`
  background: #fafbfc;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid #f3f4f6;
  text-align: center;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    border-color: ${theme.orange.orange300};
    transform: translateY(-1px);
  }
`;

export const PerformanceIcon = styled.div<any>`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: ${(props) => props.background};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 8px;
  color: ${(props) => props.color};
`;

export const PerformanceValue = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 4px;
`;

export const PerformanceLabel = styled.div`
  font-size: 11px;
  color: #6b7280;
  font-weight: 500;
`;

export const PerformanceTrend = styled.div<any>`
  font-size: 10px;
  color: ${(props) => (props.positive ? "#059669" : "#dc2626")};
  font-weight: 600;
  margin-top: 4px;
`;

export const CustomerMetrics = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MetricItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #fafbfc;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f1f5f9;
  }
`;

export const MetricItemIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: ${theme.orange.orange50};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.orange.orange500};
`;

export const MetricItemContent = styled.div`
  flex: 1;
`;

export const MetricItemLabel = styled.div`
  font-size: 11px;
  color: #6b7280;
  margin-bottom: 2px;
`;

export const MetricItemValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #111827;
`;
